if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.qtyInput = this.querySelector('.sticky-cart__qty-input');
        this.submitButton = this.querySelector('.sticky-cart__submit');
      }

      connectedCallback() {
        this.thresholdEl = document.querySelector(this.dataset.thresholdSelector);
        this.mainQtyInput = document.querySelector(this.dataset.quantitySelector);

        if (this.thresholdEl) {
          this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
            rootMargin: '0px 0px 0px 0px',
          });
          this.observer.observe(this.thresholdEl);
        }

        this.addEventListener('click', this.handleClick.bind(this));

        if (this.mainQtyInput) {
          this.mainQtyInput.addEventListener('change', () => {
            if (this.qtyInput) this.qtyInput.value = this.mainQtyInput.value;
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      handleIntersect(entries) {
        const entry = entries[0];
        const scrolledPastUpward = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('sticky-cart--visible', scrolledPastUpward);
      }

      handleClick(event) {
        const action = event.target.closest('[data-action]')?.dataset.action;

        if (action === 'increase' || action === 'decrease') {
          this.updateQuantity(action);
          return;
        }

        if (event.target.closest('.sticky-cart__submit')) {
          this.submitToMainForm();
        }
      }

      updateQuantity(action) {
        if (!this.qtyInput) return;
        const current = parseInt(this.qtyInput.value, 10) || 1;
        const next = action === 'increase' ? current + 1 : Math.max(1, current - 1);
        this.qtyInput.value = next;
      }

      submitToMainForm() {
        const mainSubmit = document.querySelector('.product-form__submit');
        if (!mainSubmit || mainSubmit.hasAttribute('disabled')) return;

        if (this.mainQtyInput && this.qtyInput) {
          this.mainQtyInput.value = this.qtyInput.value;
          this.mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        this.classList.add('is-loading');
        mainSubmit.click();

        window.setTimeout(() => {
          this.classList.remove('is-loading');
        }, 900);
      }
    }
  );
}
